import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export type CarouselItem = {
  image_url: string;
  title: string;
  link_url?: string | null;
  likes?: number | null;
  shares?: number | null;
};

export type AdBanner = {
  id: string;
  title: string;
  media_url: string | null;
  media_type: "image" | "video";
  link_url: string | null;
  cta_label: string | null;
  is_active: boolean;
  sort_order: number;
  format: "simple" | "testimonial" | "story" | "carousel";
  author_name: string | null;
  author_avatar_url: string | null;
  author_role: string | null;
  author_location: string | null;
  rating: number | null;
  quote: string | null;
  story_excerpt: string | null;
  carousel_items: CarouselItem[] | null;
  position_v: "top" | "middle" | "bottom";
  position_h: "left" | "center" | "right";
  orientation: "horizontal" | "vertical" | "diagonal";
  rotation: number;
  free_enabled: boolean;
  free_x: number;
  free_y: number;
  free_width: number;
  free_z_index: number;
  image_fit: "contain" | "cover";
};

export function useAdBanners(pageKey: string) {
  const [banners, setBanners] = useState<AdBanner[]>([]);
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const [{ data: settings }, { data: rows }] = await Promise.all([
        supabase.from("ad_page_settings").select("enabled").eq("page_key", pageKey).maybeSingle(),
        supabase.from("ad_banners").select("*").eq("is_active", true).order("sort_order", { ascending: true }),
      ]);
      if (!mounted) return;
      setEnabled(settings?.enabled ?? true);
      setBanners((rows as unknown as AdBanner[]) || []);
      setLoading(false);
    })();
    return () => {
      mounted = false;
    };
  }, [pageKey]);

  return { banners: enabled ? banners : [], enabled, loading };
}
